import { render, staticRenderFns } from "./hykod.vue?vue&type=template&id=3e52c6e3&"
import script from "./hykod.vue?vue&type=script&lang=js&"
export * from "./hykod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports